import ConfigService from './configurationService.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace Application
 */
export class Application {
    init(language, country, baseUrl, isAssessmentApp=false) {
        var tempRunConfig = {
            assessmentApp: isAssessmentApp,
            language: language,
            country: country,
            baseUrl: baseUrl
        };
        localStorage.setItem("run-config", JSON.stringify(tempRunConfig));
        console.log("Initialized application.");
    }
    initFromUrl() {
        console.log("Initializing application from url.");
        var url = window.location.href;
        var arr = url.split("/");
        var language;
        var country;
        // loop through the array until you get xx_XX or /xx/ which indicates the language
        for (var i=0; i < arr.length; i++) {
            var part = arr[i];
            if (part.match(/[a-z][a-z]_[A-Z][A-Z]/)) {
                var parts = part.split("_");
                language = parts[0];
                country = parts[1];
            } else if (part.match(/[a-z][a-z]/)) {
                if (part.isalanguage) {
                    language = part;
                }
            }
        }

        if (!country && !language) {
            // search for just language

        }

        var baseUrl = arr[0] + "//" + arr[2];
        if (!baseUrl || !language || !country) {
            throw "Could not parse init params from url:"+window.location.href;
        } else {
            console.log("Extracted params from url. baseUrl:"+baseUrl+" language:"+language+" country:"+country);
        }
        this.init(language,country, baseUrl);
    }
    getMarketConfig() {
        return ConfigService.getMarketConfig();
    }
}



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/application.js
// module id = 293
// module chunks = 0